module.exports = __webpack_public_path__ + "g.no2.586b66fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/g.no2.jpg
// module id = uY1d
// module chunks = 0